import React, { useState, useEffect } from "react";
import SecurityIcon from "../../assets/png/security.png";
import CommonModal from "../Modals/CommonModal";
// import "./Twofa.css";
import TwoFaSidebar from "../../Components/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import Navbar from "../../Components/Navbar/Navbar";
import Button from "../../Components/UIComponents/Button";

const DisableTwofa = () => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  // Function to toggle the checked state
  const toggleChecked = () => {
    setIsChecked(!isChecked);
  };
  const navigate = useNavigate();

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const reqDisable = async () => {
    try {
      setIsLoading(true);
      const twoFaDisableReq = await servicePost(
        "admin2fa/twofaDisableRequest",
        {
          email: user?.email,
        },
        notification,
        authToken
      );

      if (twoFaDisableReq.message == "SUCCESS") {
        setIsLoading(false);
        setModalShow(true);
        const updatedUser = {
          ...user,
          enableOn: false,
          twoFaRequest: true,
        };

        localStorage.setItem(
          "wealth_user",
          JSON.stringify({ data: updatedUser })
        );

        setTimeout(() => {
          setModalShow(false);
          navigate("/disable-request");
        }, 3000);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(true);
      setErrorMessage("Something went wrong.");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
    }
  };

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const cancelCode = () => {
    setIsChecked(false);
  };

  return (
    <>
      <CommonModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="An email has been sent to Disable your Two-Factor Authentication"
      />
      <Navbar />
      <TwoFaSidebar />
      <div className="twofa-guide-wrapper navbar-space-wrapper admin-sidebar-space">
        <div className="container">
          <div className="transfer-history-header">
            <img src="./images/icons/auth-logo.png" alt="icon" />
            <h3 className="twofa-desktop"> Two-Factor Authentication</h3>
            <h3 className="twofa-mobile-header"> 2F Authentication</h3>
          </div>

          <div className="twofa-enable-wrapper dashboard-twofa-enable-wrapper">
            <div className="twofa-status-wrapper">
              <img src="./images/twofa-enable.png" alt="icon" />
              <p className="twofa-status"> Status</p>
              <h2> ENABLED </h2>

              <div className="disable-twofa-input-wrap">
                <input
                  type="checkbox"
                  id="switch"
                  checked={isChecked}
                  onChange={toggleChecked}
                />
                <label for="switch">Toggle</label>
                <p> Disable 2FA</p>
              </div>
            </div>

            <div className="twofa-footer">
              <div className="twofa-security-wrapper">
                <div className="twofa-security-wrap">
                  <img src={SecurityIcon} alt="icon" />
                  <p>
                    To disable Google 2FA, YFOS will verify your request. During
                    this, account access and 2FA reset will be temporarily
                    unavailable.
                  </p>
                </div>
              </div>
              {error ? <div className="error-msg">{errorMessage}</div> : ""}
              {isChecked ? (
                <div className="confirm-button-wrapper">
                  <div className="confirm-button-wrap">
                    <Button
                      extraClass="cancel-btn"
                      label="Confirm"
                      isLoading={isLoading}
                      onClick={reqDisable}
                    />

                    <Button
                      extraClass="cancel-button"
                      label="Cancel"
                      onClick={cancelCode}
                    />
                  </div>
                </div>
              ) : (
                <div className="confirm-button-wrapper for-space-disaper-button">
                  <div className="confirm-button-wrap">
                    <button>Confirm</button>
                    <button className="cancel-button">Cancel</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisableTwofa;
